import { render, staticRenderFns } from "./ClinicDashboardPatients.vue?vue&type=template&id=20e688da&"
import script from "./ClinicDashboardPatients.vue?vue&type=script&lang=js&"
export * from "./ClinicDashboardPatients.vue?vue&type=script&lang=js&"
import style0 from "./ClinicDashboardPatients.vue?vue&type=style&index=0&id=20e688da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports